if (!customElements.get('section-faq')) {
  class FAQ extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.toggleAccordions();
    }

    toggleAccordions() {
      const faqs = this.querySelectorAll('.js-faq-trigger');
      if (!faqs) return;

      faqs.forEach((faq) => {
        faq.addEventListener('click', () => {
          const faqContent = faq.nextElementSibling;

          if (faq.classList.contains('is-open')) {
            faq.classList.remove('is-open');
            faqContent.style.maxHeight = null;
            return;
          }

          faqs.forEach((_faq) => {
            _faq.classList.remove('is-open');
            _faq.nextElementSibling.style.maxHeight = null;
          });

          faq.classList.add('is-open');
          faqContent.style.maxHeight = `${faqContent.scrollHeight}px`;
        });
      });
    }
  }

  customElements.define('section-faq', FAQ);
}
